import script from "./storage_process_view_component.vue?vue&type=script&setup=true&lang=js"
export * from "./storage_process_view_component.vue?vue&type=script&setup=true&lang=js"

import "./storage_process_view_component.vue?vue&type=style&index=0&id=c5d54090&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5d54090"]])

export default __exports__